import m from "../../geodata/es2015/burkinaFasoLow";
window.am4geodata_burkinaFasoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/burkinaFasoLow.js
// module id = null
// module chunks = 